/**
 * @template {*}
 */
class Action {

    /**
     * @type {*}
     */
    id = null

    /**
     * @param {*} id Action identifier.
     */
    constructor(id) {
        this.id = id
    }

    /**
     * Executes the action.
     *
     * Subclasses must override this method.
     *
     * @returns {Promise<T>}
     * @throws {Error} Always throws if not overridden.
     */
    async invoke() {
        throw new Error(`Action '${this.constructor.name}' with id '${this.id}' must implement invoke()`)
    }
}

export default Action
